// AUTO-GENERATED by scripts/hashAssets.mjs — do not edit by hand.
// Regenerate after dropping/replacing art: node scripts/hashAssets.mjs
// (the prebuild/pretest npm hooks run it for you.)
export const ASSET_VERSIONS: Record<string, string> = {
  "assets/backdrops/caravan.webp": "c6bdf6cbc1",
  "assets/backdrops/cliffs.webp": "ac34224740",
  "assets/backdrops/factory.webp": "80f5d4263d",
  "assets/backdrops/farmland.webp": "841742054a",
  "assets/backdrops/field_night_camp.webp": "60d68b093c",
  "assets/backdrops/finalBoss.webp": "9a8a098e52",
  "assets/backdrops/grude.webp": "8e12c85adf",
  "assets/backdrops/monastery.webp": "8321f629be",
  "assets/backdrops/mountain.webp": "1ac31e866c",
  "assets/backdrops/orinhal.webp": "4cbb1b6dfd",
  "assets/backdrops/palaceCoup.webp": "080e221fbb",
  "assets/backdrops/rusty_house.webp": "c34d2ba4bf",
  "assets/backdrops/study.webp": "1d6507a09a",
  "assets/backdrops/swamp.webp": "f545363e41",
  "assets/backdrops/tavern.webp": "c91db7fb96",
  "assets/backdrops/thuling.webp": "80e9e10652",
  "assets/camp/crates.png": "584b79018b",
  "assets/camp/firepit.png": "dc142eab19",
  "assets/camp/flames.png": "be1e80d54f",
  "assets/camp/lantern.png": "3e951e70fa",
  "assets/camp/log.png": "9f25b104dd",
  "assets/camp/memorial.png": "6ffee2595d",
  "assets/camp/pine.png": "9bb3134855",
  "assets/camp/sky.webp": "3ecfa855fd",
  "assets/camp/tent.png": "5ef39ef7a1",
  "assets/camp/wagon.png": "a55089358c",
  "assets/key/keyart.webp": "1621a77c11",
  "assets/key/keyart_1100.webp": "bf98a2ca7e",
  "assets/key/keyart_card.jpg": "31145ae942",
  "assets/obstacles/barricade.png": "e7b43fbf1c",
  "assets/obstacles/fence.png": "10b47933aa",
  "assets/obstacles/hay.png": "cda0bd2275",
  "assets/obstacles/pillar.png": "604f0f9df4",
  "assets/obstacles/rock.png": "0131a3d658",
  "assets/obstacles/tall/pillar.png": "2900733827",
  "assets/obstacles/tall/tree.png": "ccbc5648b9",
  "assets/obstacles/throne.png": "b576fcb002",
  "assets/obstacles/torch.png": "595f3b99c3",
  "assets/obstacles/tree.png": "8a7e221383",
  "assets/obstacles/wagon.png": "04ef3cb6c3",
  "assets/portraits/amar_guarded.webp": "fea2120a91",
  "assets/portraits/amar_neutral.webp": "b3e804977a",
  "assets/portraits/amar_quiet_rage.webp": "d8927d50de",
  "assets/portraits/amar_resolute.webp": "3db49573a0",
  "assets/portraits/amar_shocked.webp": "3545219cb0",
  "assets/portraits/amar_warm_half_smile.webp": "fb6d0c0a6a",
  "assets/portraits/amar_wounded.webp": "2b73ca8adc",
  "assets/portraits/archbold.webp": "d71b088f82",
  "assets/portraits/archbold_neutral.webp": "e90f56d13c",
  "assets/portraits/archbold_offering_peace.webp": "210c160f81",
  "assets/portraits/archbold_righteous_fury.webp": "463ca7eaba",
  "assets/portraits/bandit.webp": "c425b47869",
  "assets/portraits/brask.webp": "50e5ca0534",
  "assets/portraits/castor.webp": "22b0da9ffb",
  "assets/portraits/corin_battle_fury.webp": "dfcda38bb0",
  "assets/portraits/corin_neutral.webp": "b2914e35af",
  "assets/portraits/corin_quiet_grief.webp": "e2635bbfbe",
  "assets/portraits/corin_resolute.webp": "339bdcefb8",
  "assets/portraits/corin_torn.webp": "e0d72e65e0",
  "assets/portraits/coyne.webp": "6727bef2b2",
  "assets/portraits/crown_archer.webp": "02047372db",
  "assets/portraits/dawn_charismatic_warm_smile.webp": "dbdc19a6cf",
  "assets/portraits/dawn_ideologue_intensity.webp": "f0507c468f",
  "assets/portraits/dawn_mask_slipping.webp": "cf373f0be3",
  "assets/portraits/dawn_measured_neutral.webp": "d14fab4fab",
  "assets/portraits/fergus.webp": "d97d517f85",
  "assets/portraits/fergus_false_sincerity.webp": "5bb0f5b0b1",
  "assets/portraits/fergus_neutral.webp": "aaad60d8a2",
  "assets/portraits/fergus_unmasked_treachery.webp": "a84ff62c5f",
  "assets/portraits/herald.webp": "a502dbe108",
  "assets/portraits/khione.webp": "a9c53b5580",
  "assets/portraits/khione_ancient_sadness.webp": "be59203965",
  "assets/portraits/khione_neutral.webp": "0694b762cb",
  "assets/portraits/khione_revelation.webp": "2e97f04075",
  "assets/portraits/khione_serene_neutral.webp": "1adf6b8e87",
  "assets/portraits/kian.webp": "923dfec4e9",
  "assets/portraits/kian_alarmed.webp": "d72d868e64",
  "assets/portraits/kian_cold_contempt.webp": "9b54ee60e5",
  "assets/portraits/kian_fatherly_smile.webp": "399cc73f6d",
  "assets/portraits/kian_knowing_smile.webp": "031289ff11",
  "assets/portraits/kian_neutral.webp": "5092986d70",
  "assets/portraits/kian_pure_menace.webp": "e14107f4fa",
  "assets/portraits/kian_wounded.webp": "fb6c2567b1",
  "assets/portraits/leo.webp": "0a375f83b2",
  "assets/portraits/leo_cocky_smirk.webp": "86cbbda5c1",
  "assets/portraits/leo_fury.webp": "2f8928abbf",
  "assets/portraits/leo_neutral.webp": "fef868a539",
  "assets/portraits/leo_ready.webp": "fb0faa0aa4",
  "assets/portraits/leo_resolute.webp": "9aed1639a8",
  "assets/portraits/leo_wide-eyed_horror.webp": "6edf9896ec",
  "assets/portraits/leo_wounded_pride.webp": "5c4b636162",
  "assets/portraits/lucian.webp": "fcf915d7de",
  "assets/portraits/lucian_alarmed.webp": "326083bcc0",
  "assets/portraits/lucian_dying.webp": "4f223d9916",
  "assets/portraits/lucian_fatherly_smile.webp": "8422f1510d",
  "assets/portraits/lucian_grim_resolve.webp": "8a66b03501",
  "assets/portraits/lucian_neutral.webp": "81899d7a65",
  "assets/portraits/maya.webp": "5759f5cfb2",
  "assets/portraits/maya_alarmed.webp": "a12918d432",
  "assets/portraits/maya_calculating_side_glance.webp": "907092d2cc",
  "assets/portraits/maya_guarded_neutral.webp": "ec496e698b",
  "assets/portraits/maya_soft_genuine_smile.webp": "89c26b0e01",
  "assets/portraits/maya_steel_cold_confession_face.webp": "5f6ebe9e32",
  "assets/portraits/maya_tearful.webp": "697898dbe2",
  "assets/portraits/mira.webp": "9a171694b0",
  "assets/portraits/ndara.webp": "8cc8540344",
  "assets/portraits/ndara_commanding.webp": "237188734c",
  "assets/portraits/ndara_grim.webp": "097e545d54",
  "assets/portraits/ndara_military_neutral.webp": "0e2bfca3ef",
  "assets/portraits/ndara_neutral.webp": "fbda6d401b",
  "assets/portraits/ndari.webp": "517a16101d",
  "assets/portraits/ndari_grim_resolve.webp": "a09b19017c",
  "assets/portraits/ndari_knowing_smile.webp": "e6c26a3051",
  "assets/portraits/ndari_regal_neutral.webp": "d186866717",
  "assets/portraits/ndari_scornful.webp": "ef491a1722",
  "assets/portraits/ndari_surprised.webp": "4fce956925",
  "assets/portraits/nebu.webp": "f39eb3fc23",
  "assets/portraits/nebu_cruel_amusement.webp": "fef4996dd4",
  "assets/portraits/nebu_fury.webp": "79c6997e7e",
  "assets/portraits/nebu_neutral.webp": "c195cda25a",
  "assets/portraits/ning.webp": "7295cb894f",
  "assets/portraits/ning_eager_grin.webp": "5b1c855e7f",
  "assets/portraits/ning_exhausted.webp": "d6a68da61b",
  "assets/portraits/ning_focused_bow.webp": "62c7587c33",
  "assets/portraits/ning_neutral.webp": "c9a165ae2b",
  "assets/portraits/ning_startled.webp": "3c9a89c8ce",
  "assets/portraits/othren.webp": "5f7dae4c70",
  "assets/portraits/raider.webp": "22a1c8d480",
  "assets/portraits/ranatoli.webp": "c3703ba436",
  "assets/portraits/ranatoli_alarmed.webp": "00bca808ce",
  "assets/portraits/ranatoli_dry_skeptical.webp": "36c5bdf5b1",
  "assets/portraits/ranatoli_lecturing.webp": "8b40b3ede1",
  "assets/portraits/ranatoli_neutral.webp": "855adee1d0",
  "assets/portraits/ranatoli_satisfied.webp": "f022e4f048",
  "assets/portraits/ravage_commander.webp": "afdc51dde2",
  "assets/portraits/reaver.webp": "3cc0a7a305",
  "assets/portraits/rose_brisk.webp": "43a5782d12",
  "assets/portraits/rose_falling.webp": "66f7e24261",
  "assets/portraits/rose_neutral.webp": "380a2a8908",
  "assets/portraits/royal_guard.webp": "ccbe4f7a1a",
  "assets/portraits/sarto.webp": "5a6d112912",
  "assets/portraits/selene.webp": "2c1e578591",
  "assets/portraits/selene_breaking.webp": "9c8a858580",
  "assets/portraits/selene_cold_contempt.webp": "ac99cc3a4d",
  "assets/portraits/serrick.webp": "9ce19733d7",
  "assets/portraits/tali.webp": "09a060eb27",
  "assets/portraits/tali_neutral.webp": "12f3cbfab6",
  "assets/portraits/vasse.webp": "1cf32004e7",
  "assets/portraits/veya_alarmed.webp": "0511d42577",
  "assets/portraits/veya_focused.webp": "a6aa53e890",
  "assets/portraits/veya_grim_resolve.webp": "affcc3d82d",
  "assets/portraits/veya_neutral.webp": "b6f55d40e3",
  "assets/portraits/veya_wry_smile.webp": "064931d0a9",
  "assets/portraits/wren.webp": "8c45a78c51",
  "assets/screens/boss.webp": "3942aff08c",
  "assets/screens/camp.webp": "70fb2732f5",
  "assets/screens/coup.webp": "1a4b3fc90a",
  "assets/screens/crit.webp": "22b07899b8",
  "assets/screens/finale.webp": "361e36c028",
  "assets/screens/promotion.webp": "a92710c99e",
  "assets/screens/story.webp": "ff641de58e",
  "assets/screens/throne.webp": "b5c4457ba2",
  "assets/screens/victory.webp": "d0d7f6d331",
  "assets/sprites/archbold/attack.png": "2b801419d2",
  "assets/sprites/archbold/death.png": "37aff51931",
  "assets/sprites/archbold/hit.png": "f53aa2e55a",
  "assets/sprites/archbold/idle.png": "2035b3a89a",
  "assets/sprites/archbold/walk.png": "f6708f8dda",
  "assets/sprites/archer/attack.png": "d96ab00295",
  "assets/sprites/archer/death.png": "d9abc251d3",
  "assets/sprites/archer/hit.png": "7aa5df6303",
  "assets/sprites/archer/idle.png": "bb67b6fef3",
  "assets/sprites/archer/walk.png": "8683ada70b",
  "assets/sprites/bandit_archer/attack.png": "99c26f734b",
  "assets/sprites/bandit_archer/death.png": "bd8fd8d190",
  "assets/sprites/bandit_archer/hit.png": "2f24e26699",
  "assets/sprites/bandit_archer/idle.png": "603ec1b3a5",
  "assets/sprites/bandit_archer/walk.png": "169bad0189",
  "assets/sprites/bandit_spearton/attack.png": "76cfeac6df",
  "assets/sprites/bandit_spearton/death.png": "8b0e09fdd1",
  "assets/sprites/bandit_spearton/hit.png": "2578701ef0",
  "assets/sprites/bandit_spearton/idle.png": "69cd8afafc",
  "assets/sprites/bandit_spearton/walk.png": "4b987b49be",
  "assets/sprites/bandit_swordsman/attack.png": "a58590f3df",
  "assets/sprites/bandit_swordsman/death.png": "e97e67b5ee",
  "assets/sprites/bandit_swordsman/hit.png": "0a88574bb0",
  "assets/sprites/bandit_swordsman/idle.png": "d5d125cbc5",
  "assets/sprites/bandit_swordsman/walk.png": "f9387c8cba",
  "assets/sprites/boss/attack.png": "815496f2c0",
  "assets/sprites/boss/death.png": "b40970ed98",
  "assets/sprites/boss/hit.png": "820204e7a5",
  "assets/sprites/boss/idle.png": "9a88bff7e1",
  "assets/sprites/boss/walk.png": "20031e0f09",
  "assets/sprites/castor/attack.png": "e12cd867b0",
  "assets/sprites/castor/death.png": "04865d3e6f",
  "assets/sprites/castor/hit.png": "f0263fb21b",
  "assets/sprites/castor/idle.png": "a244de0e6e",
  "assets/sprites/castor/walk.png": "90572350c1",
  "assets/sprites/crown_archer/attack.png": "11c18d89ba",
  "assets/sprites/crown_archer/death.png": "c2aeda6ee8",
  "assets/sprites/crown_archer/hit.png": "23b74c6a19",
  "assets/sprites/crown_archer/idle.png": "b4429af3df",
  "assets/sprites/crown_archer/walk.png": "35cc2aaa3f",
  "assets/sprites/dactyl_king/attack.png": "4fb3b6a5fa",
  "assets/sprites/dactyl_king/death.png": "16cabee9d8",
  "assets/sprites/dactyl_king/hit.png": "7811c60b95",
  "assets/sprites/dactyl_king/idle.png": "227ca66fbc",
  "assets/sprites/dactyl_king/walk.png": "0cd0204443",
  "assets/sprites/dactyl_rider/attack.png": "87d417c6b9",
  "assets/sprites/dactyl_rider/death.png": "67523b0423",
  "assets/sprites/dactyl_rider/hit.png": "153cad3269",
  "assets/sprites/dactyl_rider/idle.png": "ab82547f6e",
  "assets/sprites/dactyl_rider/walk.png": "4b9754304b",
  "assets/sprites/dawn/attack.png": "65846afa1c",
  "assets/sprites/dawn/death.png": "64e208b779",
  "assets/sprites/dawn/hit.png": "462e5b4129",
  "assets/sprites/dawn/idle.png": "9799f41612",
  "assets/sprites/dawn/walk.png": "819fdd7e12",
  "assets/sprites/guardian/attack.png": "c90b68a0d3",
  "assets/sprites/guardian/death.png": "b36b7f40b8",
  "assets/sprites/guardian/hit.png": "1f250d73a8",
  "assets/sprites/guardian/idle.png": "f41f5ab067",
  "assets/sprites/guardian/walk.png": "3524564c79",
  "assets/sprites/herald/attack.png": "0a87b2de72",
  "assets/sprites/herald/death.png": "fa594c8c68",
  "assets/sprites/herald/hit.png": "3c19e37d9d",
  "assets/sprites/herald/idle.png": "62417944c6",
  "assets/sprites/herald/walk.png": "3b023f774f",
  "assets/sprites/khan/attack.png": "cf5f2e8cdf",
  "assets/sprites/khan/death.png": "7231d7c1f2",
  "assets/sprites/khan/hit.png": "470bd5a213",
  "assets/sprites/khan/idle.png": "a7b17f023d",
  "assets/sprites/khan/walk.png": "36d08f443b",
  "assets/sprites/kian/attack.png": "70248208c6",
  "assets/sprites/kian/death.png": "388f408844",
  "assets/sprites/kian/hit.png": "d763e41b6d",
  "assets/sprites/kian/idle.png": "f563b8073a",
  "assets/sprites/kian/walk.png": "a1963df7c3",
  "assets/sprites/knight/attack.png": "25b7769a93",
  "assets/sprites/knight/death.png": "e21183ff85",
  "assets/sprites/knight/hit.png": "5a64c04480",
  "assets/sprites/knight/idle.png": "57f263b9f8",
  "assets/sprites/knight/walk.png": "bce77b3e85",
  "assets/sprites/lenscaster/attack.png": "64ca75a4db",
  "assets/sprites/lenscaster/death.png": "8b531793e7",
  "assets/sprites/lenscaster/hit.png": "7290ffbd37",
  "assets/sprites/lenscaster/idle.png": "21c3191d3c",
  "assets/sprites/lenscaster/walk.png": "d75bb59448",
  "assets/sprites/ndari/attack.png": "f72482a491",
  "assets/sprites/ndari/death.png": "414e0f07a0",
  "assets/sprites/ndari/hit.png": "a6834d0b28",
  "assets/sprites/ndari/idle.png": "aa91c2f0de",
  "assets/sprites/ndari/walk.png": "7c40fe5ff4",
  "assets/sprites/nebu/attack.png": "fd26ef2f9c",
  "assets/sprites/nebu/death.png": "768c9ffaf1",
  "assets/sprites/nebu/hit.png": "b1ac4e094e",
  "assets/sprites/nebu/idle.png": "6f2d7f87bc",
  "assets/sprites/nebu/walk.png": "3abe9f10d9",
  "assets/sprites/othren/attack.png": "eace1de450",
  "assets/sprites/othren/death.png": "807ea8a823",
  "assets/sprites/othren/hit.png": "5ce3b70995",
  "assets/sprites/othren/idle.png": "3fbb8cfe7f",
  "assets/sprites/othren/walk.png": "f4b4c547dc",
  "assets/sprites/prismarch/attack.png": "3827811680",
  "assets/sprites/prismarch/death.png": "1560423ba7",
  "assets/sprites/prismarch/hit.png": "016458172e",
  "assets/sprites/prismarch/idle.png": "b7c2d2f348",
  "assets/sprites/prismarch/walk.png": "a582bb397b",
  "assets/sprites/ravage_commander/attack.png": "1cb52d3b52",
  "assets/sprites/ravage_commander/death.png": "5d9d7c4d0e",
  "assets/sprites/ravage_commander/hit.png": "03912c6c9b",
  "assets/sprites/ravage_commander/idle.png": "bb2a5654e4",
  "assets/sprites/ravage_commander/walk.png": "88b9fc0c38",
  "assets/sprites/ravage_lancer/attack.png": "6fc204a24b",
  "assets/sprites/ravage_lancer/death.png": "528fca1e13",
  "assets/sprites/ravage_lancer/hit.png": "5e60af9932",
  "assets/sprites/ravage_lancer/idle.png": "35d167c58e",
  "assets/sprites/ravage_lancer/walk.png": "34c634fa4c",
  "assets/sprites/ravage_marksman/attack.png": "bb66db9ccd",
  "assets/sprites/ravage_marksman/death.png": "c5bb3f27d3",
  "assets/sprites/ravage_marksman/hit.png": "2910329fba",
  "assets/sprites/ravage_marksman/idle.png": "7e674bbbb3",
  "assets/sprites/ravage_marksman/walk.png": "9c770b7071",
  "assets/sprites/ravage_trooper/attack.png": "6d1844207d",
  "assets/sprites/ravage_trooper/death.png": "06e444e63d",
  "assets/sprites/ravage_trooper/hit.png": "2aeef66dd2",
  "assets/sprites/ravage_trooper/idle.png": "a11833de02",
  "assets/sprites/ravage_trooper/walk.png": "1c8c982d7f",
  "assets/sprites/robinhelm/attack.png": "95ea150647",
  "assets/sprites/robinhelm/death.png": "d5fa977b83",
  "assets/sprites/robinhelm/hit.png": "382273d985",
  "assets/sprites/robinhelm/idle.png": "3682516e65",
  "assets/sprites/robinhelm/walk.png": "b730756c47",
  "assets/sprites/rose/attack.png": "70f3f2be6a",
  "assets/sprites/rose/death.png": "a26a35e3b0",
  "assets/sprites/rose/hit.png": "383f071a1f",
  "assets/sprites/rose/idle.png": "5a31f01077",
  "assets/sprites/rose/walk.png": "f0cf80a3b3",
  "assets/sprites/royal_guard/attack.png": "7b97278850",
  "assets/sprites/royal_guard/death.png": "f69e9af031",
  "assets/sprites/royal_guard/hit.png": "764c5b4763",
  "assets/sprites/royal_guard/idle.png": "940dc630f9",
  "assets/sprites/royal_guard/walk.png": "f24ce96800",
  "assets/sprites/sentinel/attack.png": "7646ad6218",
  "assets/sprites/sentinel/death.png": "6b4f7c4500",
  "assets/sprites/sentinel/hit.png": "89afdfd1e6",
  "assets/sprites/sentinel/idle.png": "0a792369f2",
  "assets/sprites/sentinel/walk.png": "49eaa33c02",
  "assets/sprites/serrick/attack.png": "30b745bdb0",
  "assets/sprites/serrick/death.png": "4e15b2f5a9",
  "assets/sprites/serrick/hit.png": "74f5c13dc1",
  "assets/sprites/serrick/idle.png": "08fc704bdc",
  "assets/sprites/serrick/walk.png": "26d8f151c5",
  "assets/sprites/shinobi/attack.png": "e4e2fb06c9",
  "assets/sprites/shinobi/death.png": "e0ed21c1bc",
  "assets/sprites/shinobi/hit.png": "5e004a9a47",
  "assets/sprites/shinobi/idle.png": "b6753adb4e",
  "assets/sprites/shinobi/walk.png": "21e60ae4e6",
  "assets/sprites/shinobi_master/attack.png": "aa84276abb",
  "assets/sprites/shinobi_master/death.png": "67705e935a",
  "assets/sprites/shinobi_master/hit.png": "e19d69de90",
  "assets/sprites/shinobi_master/idle.png": "721bc816e4",
  "assets/sprites/shinobi_master/walk.png": "cc4afaa8f7",
  "assets/sprites/spearton/attack.png": "24231d0fe4",
  "assets/sprites/spearton/death.png": "9678cf5dc8",
  "assets/sprites/spearton/hit.png": "c8cf34c0aa",
  "assets/sprites/spearton/idle.png": "57e870c23c",
  "assets/sprites/spearton/walk.png": "52fc3c01c7",
  "assets/sprites/spearton_lord/attack.png": "5dca326140",
  "assets/sprites/spearton_lord/death.png": "847e1ae1d0",
  "assets/sprites/spearton_lord/hit.png": "a371b4469d",
  "assets/sprites/spearton_lord/idle.png": "6eb9109a3c",
  "assets/sprites/spearton_lord/walk.png": "25d89e4c89",
  "assets/sprites/swordmaster/attack.png": "b02b498b88",
  "assets/sprites/swordmaster/death.png": "ff432e4501",
  "assets/sprites/swordmaster/hit.png": "8432f04f59",
  "assets/sprites/swordmaster/idle.png": "05eeb0203b",
  "assets/sprites/swordmaster/walk.png": "ac40c04a2c",
  "assets/sprites/swordsman/attack.png": "50be838e39",
  "assets/sprites/swordsman/death.png": "1f788f1458",
  "assets/sprites/swordsman/hit.png": "f79313ebea",
  "assets/sprites/swordsman/idle.png": "2c8d3e78a7",
  "assets/sprites/swordsman/walk.png": "3576f5bf38",
  "assets/sprites/wren/attack.png": "361f90a293",
  "assets/sprites/wren/death.png": "3ebc9ea14c",
  "assets/sprites/wren/hit.png": "9b4ced8515",
  "assets/sprites/wren/idle.png": "42b31f2684",
  "assets/sprites/wren/walk.png": "d63d6d5263",
  "assets/story/harbor_night.webp": "08adf21d23",
  "assets/story/open_sea.webp": "d39d5c9c07",
  "assets/story/ravage_ship.webp": "64979dd65b",
  "assets/story/ring.png": "a943f5789e",
  "assets/story/ring_cliff.webp": "4b988e4118",
  "assets/story/ship.webp": "484a51e3eb",
  "assets/story/throne_hall.webp": "0540a22adb",
  "assets/tiles/Obstacles.webp": "88b79ee6e0",
  "assets/tiles/cobblestone.webp": "763b8868e5",
  "assets/tiles/cracked_earth.webp": "2114e1c7bb",
  "assets/tiles/dirt.webp": "26f243a60e",
  "assets/tiles/door.webp": "300c173a3a",
  "assets/tiles/forest.webp": "e14a0c4c8f",
  "assets/tiles/grass.webp": "e4ca4c5421",
  "assets/tiles/ice.webp": "4ca7c7c200",
  "assets/tiles/lava.webp": "7480d0b1fb",
  "assets/tiles/marble.webp": "4275c92d51",
  "assets/tiles/moss_stone.webp": "592e6ae702",
  "assets/tiles/mud.webp": "cce333e9c8",
  "assets/tiles/rubble.webp": "a1eb06b903",
  "assets/tiles/sand.webp": "c1653b5e3e",
  "assets/tiles/snow.webp": "fa6e5bf85e",
  "assets/tiles/stone.webp": "6fbe694d4b",
  "assets/tiles/wall.webp": "34ee6996e6",
  "assets/tiles/water.webp": "b8457fd7cf",
  "assets/tiles/wood.webp": "13601b26ec",
  "assets/vfx/heal.png": "d6aec51d86",
  "assets/vfx/impact.png": "e93f176102",
  "assets/vfx/slash.png": "6b0d17623e",
  "assets/vfx/slash_crit.png": "61bd264c41",
  "audio/Death.mp3": "db4a0ff0f0",
  "audio/Emotional_Life.mp3": "4e4fc92d68",
  "audio/Final Battle Attack.mp3": "6bd9d98719",
  "audio/Final Battle Sad.mp3": "6026a55078",
  "audio/GrudeBattle1.mp3": "1ff80db984",
  "audio/Intense Battle V2.mp3": "f3b0e3a678",
  "audio/Intense Battle V3.mp3": "870d5f3a45",
  "audio/Ravage_Daredevil.mp3": "20033ba38c",
  "audio/Sadness.mp3": "e34a2388df",
  "audio/Sadness2.mp3": "6fcc9cceb7",
  "audio/Spine of the World - Battle 2.mp3": "5493b6f142",
  "audio/Spine of the World - Battle.mp3": "4f79eb69c2",
  "audio/Spine of the World - Emotional Scenes.mp3": "6fc7e3e937",
  "audio/Spine of the World - Everyday.mp3": "6fcc9cceb7",
  "audio/Spine of the World - Main Game Theme.mp3": "57be96dcb1",
  "audio/Spine of the World - Trailer.mp3": "8920df1657",
  "audio/adventure_1.mp3": "05ee151000",
  "audio/adventure_in_anthros.mp3": "90fbe5be90",
  "audio/battle_preparation.mp3": "d6d01b0013",
  "audio/danger.mp3": "d356d4ec17",
  "audio/entering_the_stronghold.mp3": "a4490757a8",
  "audio/everyday_in_anthros.mp3": "795f832d8b",
  "audio/final_boss1.mp3": "50a526850c",
  "audio/life_in_grude.mp3": "823848ff96",
  "audio/stronghold_of_memories.mp3": "3df9091cc3"
};
